/**
 * Channel-specific activity-log `type` → display-name pairs (e.g. `sent_sms` → "Sent SMS").
 *
 * This is a static `{ logType: displayName }` map. Once the channel registry lives in Hydra,
 * these names should be re-derived from it so a newly-added channel type gets a label
 * automatically instead of falling back to its raw value. Until then, a channel type missing
 * here renders raw.
 */
export const CHANNEL_LOG_TYPE_NAMES: Record<string, string> = {
  attempted_email: 'Attempted to send email',
  attempted_in_app: 'Attempted to send in-app message',
  attempted_inbox: 'Attempted to send inbox message',
  attempted_line: 'Attempted to send LINE message',
  attempted_live_notification: 'Attempted to send live notification',
  attempted_push: 'Attempted to send push notification',
  attempted_slack: 'Attempted to send Slack message',
  attempted_sms: 'Attempted to send SMS',
  attempted_twilio: 'Attempted to send SMS',
  attempted_webhook: 'Attempted to send webhook',
  attempted_whatsapp: 'Attempted to send WhatsApp message',
  bounced_email: 'Bounced email',
  bounced_live_notification: 'Bounced live notification',
  bounced_push: 'Bounced push notification',
  bounced_sms: 'Bounced SMS',
  bounced_twilio: 'Bounced SMS',
  clicked_email: 'Clicked email',
  clicked_in_app: 'Clicked in-app message',
  clicked_line: 'Clicked LINE message',
  clicked_push: 'Clicked push notification',
  clicked_sms: 'Clicked SMS',
  clicked_twilio: 'Clicked SMS',
  clicked_webhook: 'Clicked webhook',
  converted_email: 'Converted email',
  converted_in_app: 'Converted in-app message',
  converted_inbox: 'Converted inbox message',
  converted_line: 'Converted LINE message',
  converted_slack: 'Converted Slack message',
  converted_sms: 'Converted SMS',
  converted_twilio: 'Converted SMS',
  converted_webhook: 'Converted webhook',
  converted_whatsapp: 'Converted WhatsApp message',
  deferred_email: 'Deferred email',
  deferred_in_app: 'Deferred in-app message',
  deferred_inbox: 'Deferred inbox message',
  deferred_push: 'Deferred push notification',
  deferred_slack: 'Deferred Slack message',
  deferred_sms: 'Deferred SMS',
  deferred_twilio: 'Deferred SMS',
  deferred_webhook: 'Deferred webhook',
  delivered_email: 'Delivered email',
  delivered_line: 'Delivered LINE message',
  delivered_live_notification: 'Delivered live notification',
  delivered_push: 'Delivered push notification',
  delivered_sms: 'Delivered SMS',
  delivered_twilio: 'Delivered SMS',
  delivered_whatsapp: 'Delivered WhatsApp message',
  drafted_email: 'Drafted email',
  drafted_in_app: 'Drafted in-app message',
  drafted_inbox: 'Drafted inbox message',
  drafted_push: 'Drafted push notification',
  drafted_slack: 'Drafted Slack message',
  drafted_sms: 'Drafted SMS',
  drafted_twilio: 'Drafted SMS',
  drafted_webhook: 'Drafted webhook',
  dropped_email: 'Suppressed email',
  failed_email: 'Failed to send email',
  failed_in_app: 'Failed to send in-app message',
  failed_inbox: 'Failed to send inbox message',
  failed_line: 'Failed to send LINE message',
  failed_live_notification: 'Failed to send live notification',
  failed_push: 'Failed to send push notification',
  failed_slack: 'Failed to send Slack message',
  failed_sms: 'Failed to send SMS',
  failed_twilio: 'Failed to send SMS',
  failed_webhook: 'Failed to send webhook',
  failed_whatsapp: 'Failed to send WhatsApp message',
  opened_email: 'Opened email',
  opened_in_app: 'Opened in-app message',
  opened_inbox: 'Opened inbox message',
  opened_live_notification: 'Opened live notification',
  opened_push: 'Opened push notification',
  opened_whatsapp: 'Opened WhatsApp message',
  replied_sms: 'Replied to SMS',
  replied_twilio: 'Replied to SMS',
  replied_whatsapp: 'Replied to WhatsApp message',
  sent_email: 'Sent email',
  sent_in_app: 'Sent in-app message',
  sent_inbox: 'Sent inbox message',
  sent_line: 'Sent LINE message',
  sent_live_notification: 'Sent live notification',
  sent_push: 'Sent push notification',
  sent_slack: 'Sent Slack message',
  sent_sms: 'Sent SMS',
  sent_twilio: 'Sent SMS',
  sent_webhook: 'Sent webhook',
  sent_whatsapp: 'Sent WhatsApp message',
  spammed_email: 'Spammed email',
  suppressed_sms: 'Suppressed SMS',
  suppressed_twilio: 'Suppressed SMS',
  topic_unsubscribed_email: 'Topics unsubscribed email',
  undeliverable_email: 'Undeliverable email',
  undeliverable_in_app: 'Undeliverable in-app message',
  undeliverable_inbox: 'Undeliverable inbox message',
  undeliverable_live_notification: 'Undeliverable live notification',
  undeliverable_push: 'Undeliverable push notification',
  undeliverable_slack: 'Undeliverable Slack message',
  undeliverable_sms: 'Undeliverable SMS',
  undeliverable_twilio: 'Undeliverable SMS',
  undeliverable_webhook: 'Undeliverable webhook',
  unsubscribed_email: 'Unsubscribed email',
};
